import { Link } from "react-router-dom";
import { SecretaryLayout } from "../Layout";
import { PatientsTable } from "../components";
import { NotClearedSurgeriesTable } from "../components/tables";

export const PatientsPage = () => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="d-md-flex justify-content-between mb-2">
            <h5 className="mb-0">Lista de pacientes</h5>
            <nav
              aria-label="breadcrumb"
              className="d-inline-block mt-4 mt-sm-0"
            >
              <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/secretary/dashboard">Gosafe</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Pacientes
                </li>
              </ul>
            </nav>
          </div>

          <PatientsTable />
        </div>
      </div>
    </SecretaryLayout>
  );
};
